<div class="container">
    <div class="text-center hidden-scrollbar">
        <h3>The server seems to be down... please come back later</h3>
        <!--TODO: make background transparent-->
        <img src="/assets/images/server-down.gif">
        <div>
            <button class="btn btn-success btn-lg" (click)="goToHome()">Try Again</button>
        </div>
    </div>
</div>